import React, { useState } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import UserMenu from './UserMenu/index.js';
import { LogOut } from '../../services/auth.js';
import useLocalStorage from "../../hooks/useLocalStorage";
import Divider from '@mui/material/Divider';
import './index.css';
import Support from '../Support/index.js';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

function TopMenu() {
  const [ openMenu, setOpenMenu ] = useState(false);
  const [ tokenLocalStorage, setTokenLocalStorage ] = useLocalStorage('@login-mastermotion/token', null);
  const [ , setUserLocalStorage ] = useLocalStorage('@login-mastermotion/user', null);

  // const handleLoginSuccess = (response) => {
  //   const decoded = jwt_decode(response.credential);
  //   console.log("Usuário autenticado:", decoded);
  // };

  // const handleLoginFailure = () => {
  //   console.log("Falha no login.");
  // };
  
  async function logout() {
    await LogOut(tokenLocalStorage);
    setTokenLocalStorage(null);
    setUserLocalStorage(null);
    window.location.replace('https://www.reanimateads.com.br')
  }

  return (
    <div className='mainTopMenu'>
          {/* <GoogleOAuthProvider clientId="SEU_CLIENT_ID_AQUI">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <GoogleLogin
                onSuccess={handleLoginSuccess}
                onError={handleLoginFailure}
                width="300"
              />
            </div>
          </GoogleOAuthProvider> */}
      <div style={{display: 'flex', justifyContent: 'space-between', width: '70px'}}>
        <svg onClick={() => window.location.replace("https://www.reanimateads.com.br/")}  style={{cursor: 'pointer'}} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="28" height="23" viewBox="0 0 28 23">
          <defs>
              <clipPath id="clipPath">
              <rect id="Retângulo_33" data-name="Retângulo 33" width="23.686" height="19.721" fill="#dc1a59"/>
              </clipPath>
          </defs>
          <g id="Componente_37_1" data-name="Componente 37 – 1" transform="translate(1)">
              <g id="Grupo_263" data-name="Grupo 263">
              <path id="Retângulo_158" data-name="Retângulo 158" d="M0,0H12.5A11.5,11.5,0,0,1,24,11.5v0A11.5,11.5,0,0,1,12.5,23H10.542A10.542,10.542,0,0,1,0,12.458V0A0,0,0,0,1,0,0Z" fill="#ececec" opacity="0"/>
              <text id="Início" transform="translate(13 15)" fill="#dc1a59" fontSize="11" fontFamily="SegoeUI, Segoe UI" opacity="0"><tspan x="-13.003" y="0">Início</tspan></text>
              </g>
              <g id="Grupo_89" data-name="Grupo 89" transform="translate(0 2)" clipPath="url(#clipPath)">
              <path id="Caminho_151" data-name="Caminho 151" d="M11.133,1.183l-9.58,6.3a1.292,1.292,0,0,0-.582,1.08v8.891a1.292,1.292,0,0,0,1.292,1.293h5.8a1.292,1.292,0,0,0,1.292-1.293V12.919a1.293,1.293,0,0,1,1.293-1.292h2.4a1.293,1.293,0,0,1,1.293,1.292v4.539a1.292,1.292,0,0,0,1.292,1.293h5.8a1.293,1.293,0,0,0,1.292-1.293V8.567a1.3,1.3,0,0,0-.582-1.08l-9.58-6.3A1.291,1.291,0,0,0,11.133,1.183Z" transform="translate(0 0)" fill="#1B9ADA"/>
              </g>
          </g>
        </svg>
        <svg onClick={() => logout()} style={{cursor: 'pointer'}} id="Componente_38_1" data-name="Componente 38 – 1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18" height="23" viewBox="0 0 18 23">
          <defs>
            <clipPath id="clipPath">
              <rect id="Retângulo_34" data-name="Retângulo 34" width="17.542" height="19.976" fill="none"/>
            </clipPath>
          </defs>
          <g id="ico_sair" transform="translate(0 2)">
            <g id="Grupo_91" data-name="Grupo 91" transform="translate(0 0)" clipPath="url(#clipPath)">
              <path id="Caminho_152" data-name="Caminho 152" d="M10.7,6.457V2.262A1.293,1.293,0,0,0,9.411.97H2.263A1.292,1.292,0,0,0,.971,2.262V17.713A1.291,1.291,0,0,0,2.263,19H9.411A1.292,1.292,0,0,0,10.7,17.713V13.425" transform="translate(0 0)" fill="none" stroke="#1B9ADA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.941"/>
              <path id="Caminho_153" data-name="Caminho 153" d="M14.031,7.177l2.35,2.35a.652.652,0,0,1,0,.921l-2.35,2.35" transform="translate(0 0)" fill="none" stroke="#1B9ADA" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.941"/>
              <line id="Linha_1" data-name="Linha 1" x1="10.193" transform="translate(6.113 9.988)" fill="none" stroke="#1B9ADA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.941"/>
            </g>
          </g>
          <g id="Grupo_264" data-name="Grupo 264">
            <path id="Retângulo_158" data-name="Retângulo 158" d="M0,0H8.609A9.391,9.391,0,0,1,18,9.391v4.217A9.391,9.391,0,0,1,8.609,23h0A8.609,8.609,0,0,1,0,14.391V0A0,0,0,0,1,0,0Z" fill="#ececec" opacity="0"/>
            <text id="Sair" transform="translate(9 15)" fill="#dc1a59" fontSize="11" fontFamily="SegoeUI, Segoe UI" opacity="0"><tspan x="-8.964" y="0">Sair</tspan></text>
          </g>
        </svg>
      </div>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '250px', margin: '0 0 0 -120px'}}>
        <img src="assets/logoreanimatenew.png" style={{margin: '0 0 0 0'}} alt="logo"></img>
        <Divider style={{width: '28px', margin: '0 0 0 0', transform: 'rotate(90deg)'}}/>
        <p style={{marginTop:'15px', fontSize:'14px', fontWeight: 'bold', color:'#1B9ADA', userSelect: 'none'}}>Master Motion</p>
      </div>
      {/* <Support/> */}
      <div style={{margin: '5px 0 0 0'}}>
        <AccountCircleIcon onClick={() => setOpenMenu(!openMenu)} style={{cursor: 'pointer', color: '#1B9ADA'}}/>
        <UserMenu open={openMenu}/>
      </div>
    </div>
  )
}

export default TopMenu;
